angular
	.module 'App.Repository'
	.factory 'PromotionBenefitProductCategoriesRepository', ['BaseRepository', (BaseRepository) ->
		class PromotionBenefitProductCategoriesRepository extends BaseRepository
			@resource = '/promotion_benefit_product_categories'
			@isRestricted = true

			loadByPromotionCampaignId: (campaignId) ->
				query = @createQuery()

				query.criteria 'promotion_campaign_id', '=', campaignId
				query.with 'product_category'

				return @getEntities query

		return new PromotionBenefitProductCategoriesRepository()
	]
